import {Component, OnInit, Output, EventEmitter, Input, ElementRef} from '@angular/core';
import {TdoSubnavEvent} from '../tdo-subnav.event';
import {TdoSubnavItemModel} from '../models/tdo-subnav-item.model';

@Component({
  selector: 'app-tdo-subnav-item',
  templateUrl: './tdo-subnav-item.component.html',
  styleUrls: ['./tdo-subnav-item.component.scss']
})
export class TdoSubnavItemComponent implements OnInit {
  @Output() selected = new EventEmitter<any>();
  @Input() isSelected: boolean = false;
  @Input() name: string;
  @Input() model: TdoSubnavItemModel;

  private _isHovered = false;

  isShowMenu: boolean = false;

  constructor() { }

  ngOnInit(): void {
    /*this.name = this.elRef.nativeElement.innerText;
    this.name = this.name.toLowerCase().replace(' ', '-');*/
  }

  select() {
    if (this.model.children.length === 0) {
      this.isSelected = true;
      this.selected.emit(new TdoSubnavEvent(this.name, this));
    }
  }

  onMouseOver() {
    this._isHovered = true;
    if (this.model && this.model.children.length > 0) {
      this.isShowMenu = true;
    }
  }

  onMouseOut() {
    this._isHovered = false;
    this.isShowMenu = false;
  }

  get isHovered() {
    return !this.isSelected && this._isHovered;
  }

  onMenuItemClick(child: TdoSubnavItemModel) {
    this.selected.emit(new TdoSubnavEvent(child.label.toLowerCase(), this));
  }
}
